import http from '@/utils/http';
const base_path = '/v2/tool/starDelivery';

/**
 * 获取星广联投任务已投稿达人列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getStarDeliveryTaskAuthorListApi = (params) => {
  return http.get({
    url: `${base_path}/taskAuthor`,
    params,
  });
};

/**
 * 获取获取星广联投任务列表页列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getStarDeliveryTaskListApi = (params) => {
  return http.get({
    url: `${base_path}/task`,
    params,
  });
};

/**
 * 获取星广联投任务下达人视频列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getTaskAuthorVideoListApi = (params) => {
  return http.get({
    url: `${base_path}/taskAuthorVideo`,
    params,
  });
};
